module.exports = __webpack_public_path__ + "static/fbcamplogo.40f6dfb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fbcamplogo.png
// module id = 1351
// module chunks = 58691923486625 246501157640856